// Share helpers for generated content — used by ContentPage (history row) and
// ContentViewModal (full view). All handlers append the user's viral/branding
// signature via the getSignature() callback supplied by the page.
import { toast } from "@/pages/shared";

// Free plan = forced PLG signature with referral link (driver of growth).
// Paid plans honor white-label branding (custom signature / powered-by toggle).
export const buildViralSignature = (user, branding) => {
  if (user?.plan === "free") {
    const refCode = user?.referral_code || "";
    return `\n\n⚡ Monetized via Creatara ${window.location.origin}/register?ref=${refCode}`;
  }

  const parts = [];
  const customSig = (branding?.custom_signature || "").trim();
  const showPoweredBy = branding?.powered_by_enabled !== false; // default true

  // Enterprise users with a custom signature get only their signature
  // (and can fully suppress the "Powered by" line via toggle).
  if (user?.plan === "enterprise") {
    if (customSig) parts.push(customSig);
    // Avoid "… Powered by Creatara · Powered by Creatara" when the custom
    // signature already mentions it.
    if (showPoweredBy && !/powered by creatara/i.test(customSig)) parts.push("Powered by Creatara");
    return parts.length ? `\n\n— ${parts.join(" · ")}` : "";
  }

  // Pro plan: append custom signature only if provided; no forced footer.
  if (customSig) return `\n\n— ${customSig}`;
  return "";
};

export const makeShareHandlers = (getSignature) => ({
  shareToTwitter: (content) => {
    let tweetText = content.generated_content + getSignature();
    if (tweetText.length > 275) tweetText = tweetText.substring(0, 272) + "...";
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`, "_blank");
  },
  shareToLinkedIn: (content) => {
    const text = (content.generated_content + getSignature()).substring(0, 700);
    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.origin)}&title=${encodeURIComponent(content.topic)}&summary=${encodeURIComponent(text)}`, "_blank");
  },
  shareToFacebook: (content) => {
    const text = (content.generated_content + getSignature()).substring(0, 500);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.origin)}&quote=${encodeURIComponent(text)}`, "_blank");
  },
  shareToWhatsApp: (content) => {
    const text = content.generated_content + getSignature();
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`, "_blank");
  },
  copyForInstagram: (content) => {
    navigator.clipboard.writeText(content.generated_content + getSignature());
    toast.success("Copied for Instagram! Open Instagram and paste into your caption.");
  },
  copyForTikTok: (content) => {
    navigator.clipboard.writeText(content.generated_content + getSignature());
    toast.success("Copied for TikTok! Open TikTok and paste into your caption/description.");
  },
  copyWithSignature: (text) => {
    navigator.clipboard.writeText(text + getSignature());
    toast.success("Copied!");
  },
});
